export const BILL_SUPPLY_TYPE_MAP = {
  MNT: "관리비",
  RENTAL: "이용료",
};
